import React from 'react';
import { Route } from '../Routing/types';
import {
  UserMealsIndexPage,
  UserMealsSearchPage,
  UserMealDetailsPage,
  TrackerAddUserMealPage,
  TrackerAddIngredientPage,
  TrackerScanBarCodeIngredientPage,
  TrackerScanPlatePage,
  TrackerScanPlateDetailsPage,
  TrackerScanBarCodePage,
  TrackerDescribeMealPage,
  TrackerDescribeMealVoicePage,
  TrackerAddDescribeMealPage,
  TrackerDescribeManualMealPage,
} from '@front-activerse/modules';
import mealsNavigation from '../navigation/mealsNavigation';

const descendantRoutes: Route[] = [
  {
    path: `/`,
    element: <UserMealsIndexPage mealsNavigation={mealsNavigation} />,
    private: true,
    title: 'meals.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/search',
    element: <UserMealsSearchPage />,
    private: true,
    title: 'yourMeal.search.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: `/:mealId`,
    element: <UserMealDetailsPage />,
    private: true,
    title: 'tracker.mealDetails.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/:mealId/add-ingredient/',
    element: <TrackerAddIngredientPage />,
    private: true,
    title: 'tracker.logMeal.addIngredient.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/:mealId/add-ingredient/scan-barcode/',
    element: <TrackerScanBarCodeIngredientPage />,
    private: true,
    title: 'tracker.scanBarcode.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/module/tracker/add-meal/:dietMealId',
    element: <TrackerAddUserMealPage />,
    private: true,
    title: 'tracker.logMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/module/tracker/add-meal/:dietMealId/add-ingredient/',
    element: <TrackerAddIngredientPage />,
    private: true,
    title: 'tracker.logMeal.addIngredient.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/module/tracker/add-meal/:dietMealId/add-ingredient/scan-barcode/',
    element: <TrackerScanBarCodeIngredientPage />,
    private: true,
    title: 'tracker.scanBarcode.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/scan-plate',
    element: <TrackerScanPlatePage fromUserMeals={true} />,
    private: true,
    title: 'tracker.scanPlate.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/scan-plate/details',
    element: <TrackerScanPlateDetailsPage fromUserMeals={true} />,
    private: true,
    title: 'tracker.analizeMeal.ingredients.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/scan-barcode',
    element: <TrackerScanBarCodePage fromUserMeals={true} />,
    private: true,
    title: 'tracker.scanBarcode.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/describe-meal',
    element: <TrackerDescribeMealPage fromUserMeals={true} />,
    private: true,
    title: 'tracker.describeFood.navbar.Title',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/describe-manual-meal',
    element: <TrackerDescribeManualMealPage fromUserMeals={true} />,
    private: true,
    title: 'tracker.logMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/describe-meal/by-voice',
    element: <TrackerDescribeMealVoicePage fromUserMeals={true} />,
    private: true,
    title: 'tracker.describeFood.byVoice.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/describe-meal/meal-details/:dietMealId',
    element: <TrackerAddDescribeMealPage fromUserMeals={true} />,
    private: true,
    title: 'tracker.mealDetails.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/describe-meal/meal-details/:dietMealId/add-ingredient',
    element: <TrackerAddIngredientPage />,
    private: true,
    title: 'tracker.logMeal.addIngredient.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/describe-meal/meal-details/:dietMealId/add-ingredient/scan-barcode',
    element: <TrackerScanBarCodeIngredientPage />,
    private: true,
    title: 'tracker.scanBarcode.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
];

export default descendantRoutes;
